var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQiblaIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    fill: "#42B65F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0256 85.4185L132.268 48.6526C141.812 44.4872 151.513 54.1877 147.347 63.732L110.582 147.974C106.329 157.717 92.2521 156.916 89.1336 146.753L81.5501 122.04C80.4355 118.408 77.5924 115.564 73.9601 114.45L49.247 106.866C39.0842 103.748 38.2825 89.6706 48.0256 85.4185Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiblaIcn);
export default __webpack_public_path__ + "static/media/qibla_icn.4a2ae94531db4ee3071d7f2c4bb03063.svg";
export { ForwardRef as ReactComponent };